module.exports = __webpack_public_path__ + "img/section3CardRightIconm.aa5467b4.svg";